import { captureException } from '@web/common';
import { t } from 'i18next';
import { Empty } from 'rc-ui-lib';
import { Component, ErrorInfo, ReactNode } from 'react';
import type { BaseComponentProps } from '..';

type State = {
  hasError: boolean;
};

class ComponentErrorBoundary extends Component<BaseComponentProps, State> {
  static getDerivedStateFromError() {
    return { hasError: true };
  }

  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.log({
      error,
      info,
    });
    this.setState({
      hasError: true,
    });

    if (String(import.meta.env.VITE_APP_STARTSENTRY) === 'true') {
      // 组件级别错误
      captureException(error, 7, {
        extra: info,
      });
    }
  }

  render(): ReactNode {
    const { hasError } = this.state;
    const { children } = this.props;
    if (hasError) {
      return <Empty description={t('errorBoundary.defaultError')} />;
    }
    return children;
  }
}

export default ComponentErrorBoundary;
